export default __webpack_public_path__ + "static/media/into-the-wild-desktop.f5f05955.mp4";